import axios from 'axios';
import { SERVER } from '../../constants/networkUrls';
import {getCurrentTimeStamp} from './timestamp.js'
import {getGUIDCookie} from './guidTrack.js'
import apiConfig from '../trustBuilder/Auth/services/apiConfig';

const hostname = window && window.location && window.location.hostname;
const environmentConstants = apiConfig.setEnvironmentURLs(hostname);

const fmsSessionTrack = (userType, formLoaded, funnelDropParams) => {
  let authConfig = {
    headers: {
      "X-API-KEY": environmentConstants.apiKey,
    },
  };

  const fmsTrackCountURL = `${SERVER.API_BASE_URL}${SERVER.SERVICES.FMS_SESSION_TRACK}/${getGUIDCookie()}`;

  // Prepare the post data
  const postBody = {
    sessionId: getGUIDCookie(),
    userType: userType,
    isFormLoaded: formLoaded,
    loginDateTime: formLoaded ? null : getCurrentTimeStamp(),
    formLoadDateTime: formLoaded ? getCurrentTimeStamp() : null,
  };

  // Check if funnelDropParams is provided and not null
  if (funnelDropParams && typeof funnelDropParams === 'object') {
    const funnelDropKeys = [
      "isComplaintSelected", 
      "isIncidentSelected", 
      "isCommentEntered", 
      "isPictureUploaded", 
      "isEmailChecked", 
      "isPrivacyPolicyChecked", 
      "isEmailEntered",
      "isVandalismIncident",
      "isVandalismTypeSelected",
      "isPhoneNumberEntered",
      "switchedFromVisitorToEmployee",
      "assetIdEntered",
      "assetIdNotVisible"
    ];

    funnelDropKeys.forEach((key) => {
      if (funnelDropParams[key] !== null && funnelDropParams[key] !== undefined) {
        postBody[key] = funnelDropParams[key];
      }
    });
  }

  // Send data to the server
  axios.put(fmsTrackCountURL, postBody, authConfig)
    .then(response => {
      console.log("Response of FMS count:", response);
    })
    .catch(error => {
      console.log("Error of FMS count:", error);
    });
};

export {fmsSessionTrack}



